import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfirmDialogInputComponent } from './confirm-dialog-input.component';
import { MatDialogModule } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ReactiveFormsModule } from '@angular/forms';



@NgModule({
  declarations: [
    ConfirmDialogInputComponent
  ],
  imports: [
    CommonModule,
    TranslateModule,
    MatIconModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatButtonModule
  ]
})
export class ConfirmDialogInputModule { }
